export default __webpack_public_path__ + "static/media/CE5649EA-E2C5-4DDB-8F44-93B14A36B353_1_105_c.3768fc5a.jpeg";